import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Shriftlar — self-host (Vite woff2'ni lokal bundle'ga chiqaradi, CDN yo'q).
// Inter — matn/sarlavha; JetBrains Mono — label/raqamlar (metrikalar, summalar, .tabular).
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import '@fontsource/jetbrains-mono/600.css'
import './index.css'
import { App } from '@/App'
import { initTelegram } from '@/lib/telegram'

async function main(): Promise<void> {
  // Wait for the Telegram bootstrap (or its graceful no-op outside Telegram) so the first
  // render already reflects the real environment / user, then mount.
  await initTelegram()

  const container = document.getElementById('root')
  if (!container) {
    throw new Error("root elementi topilmadi ('#root')")
  }

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void main()
